import {
  appetite_rows,
  department_cards,
  heatmap_likelihood_labels,
  heatmap_rows,
  impact_options,
  likelihood_options,
  register_cards,
  risk_categories,
  risk_rows,
  risk_statuses,
  tabs
} from './risks_dashboard_data';
import {
  createDefaultRiskForm,
  enrich_appetite_row
} from './risks_dashboard_helpers';
import { buildRiskDrawerCatalog } from './risks_dashboard_drawers';
import {
  risks_dashboard_before_unmount,
  risks_dashboard_computed,
  risks_dashboard_methods,
  risks_dashboard_mounted
} from './risks_dashboard_ui';

export default {
  name: 'ComplyonRisks',
  data: () => ({
    tabs: tabs.map((tab) => ({ ...tab })),
    active_tab: 'register',
    register_cards: register_cards.map((card) => ({ ...card })),
    risk_rows: risk_rows.map((row) => ({ ...row, status: { ...row.status } })),
    risk_drawer_catalog: buildRiskDrawerCatalog(),
    active_risk_drawer_key: null,
    heatmap_rows,
    heatmap_likelihood_labels,
    appetite_rows: appetite_rows.map((row) => enrich_appetite_row({ ...row })),
    department_cards: department_cards.map((card) => ({ ...card, rows: card.rows.map((row) => ({ ...row })) })),
    show_risk_modal: false,
    risk_categories,
    risk_statuses,
    likelihood_options,
    impact_options,
    risk_form: createDefaultRiskForm()
  }),
  computed: risks_dashboard_computed,
  mounted: risks_dashboard_mounted,
  beforeUnmount: risks_dashboard_before_unmount,
  methods: risks_dashboard_methods
};
